module.exports = __webpack_public_path__ + "static/media/warning-sign-red.3f89ca47.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/warning-sign-red.svg
// module id = 698
// module chunks = 0